'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const WizardSidebarTimelineNotDoneIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="WizardSidebarTimelineNotDoneIcon">
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="8" fill="white" stroke="#B1B9CA" strokeWidth="2" />
      </svg>
    </SvgIcon>
  )
}

WizardSidebarTimelineNotDoneIcon.propTypes = {
  sx: PropTypes.object
}
